import _get from './get';
import _post from './post';

const PollManager = {
	_get,
	_post
};

export default PollManager;
